import type { SVGProps } from 'react';

const SvgHeadspaceApp = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="smart-send-time">
      <path d="M28 .36H4A3.6 3.6 0 0 0 .36 4v24A3.6 3.6 0 0 0 4 31.64h24a3.6 3.6 0 0 0 3.6-3.6V4A3.6 3.6 0 0 0 28 .36M30.14 28a2.1 2.1 0 0 1-2.1 2.1H4A2.1 2.1 0 0 1 1.86 28V4A2.1 2.1 0 0 1 4 1.86h24A2.1 2.1 0 0 1 30.14 4Z" />
      <path d="M26.35 14.31a11.93 11.93 0 0 0-6 2v-.65a15.5 15.5 0 0 0-3.88-10.29.77.77 0 0 0-1.12 0 15.54 15.54 0 0 0-3.92 10.33v.65a12 12 0 0 0-6-2 .72.72 0 0 0-.57.22.76.76 0 0 0-.22.57 11.88 11.88 0 0 0 11.23 11.14H16A11.9 11.9 0 0 0 27.14 15.1a.75.75 0 0 0-.79-.79M15.91 7a14.05 14.05 0 0 1 0 17.33 14.09 14.09 0 0 1 0-17.33m-9.63 8.9a10.24 10.24 0 0 1 5.38 2.49 15.45 15.45 0 0 0 2.53 6.13 10.34 10.34 0 0 1-7.91-8.62m16.33 5.86a10.3 10.3 0 0 1-5 2.76 15.5 15.5 0 0 0 2.52-6.12 10.4 10.4 0 0 1 5.39-2.5 10.34 10.34 0 0 1-2.91 5.86" />
    </g>
  </svg>
);

export default SvgHeadspaceApp;
